import React from 'react'
import { Route, RouteProps, Redirect } from 'react-router-dom'
import { setActiveAuthorizationId } from 'graphql/multisession'
import { useUserAuthorizations } from 'modules/sso/operations'
import { LocationDescriptor } from 'history'
import { useApolloClient } from 'react-apollo'

interface PersonalAuthRouteProps extends RouteProps {
  fallbackRouteIfUserOnlyHasSsoAuth?: (props: RouteProps) => LocationDescriptor
}

/**
 * Sets the personal session (if any) as active. Making all requests fired from
 * this route use the personal token.
 */
const PersonalAuthRoute: React.FC<PersonalAuthRouteProps> = ({
  fallbackRouteIfUserOnlyHasSsoAuth,
  ...props
}) => {
  const { authorizations, hasPersonalAuthorization } = useUserAuthorizations()
  const apolloClient = useApolloClient()

  if (
    !hasPersonalAuthorization &&
    authorizations.length > 0 &&
    fallbackRouteIfUserOnlyHasSsoAuth
  ) {
    return <Redirect to={fallbackRouteIfUserOnlyHasSsoAuth(props)} />
  }

  setActiveAuthorizationId({ type: 'personal' }, apolloClient.cache)

  return <Route {...props} />
}

export default PersonalAuthRoute
